import {
  Chip,
  Tooltip
} from '@mui/material'

import { type Item } from 'src/types'

const itemBlockStyle = {
  border: '1px dashed white',
  color: 'white',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent'
  }
}

type ItemBlockProps = {
  item?: Item
  color?: string
  defaultLabel?: string
  handleClick: (itemID: string) => void
}

const ItemBlock = ({ item, handleClick, defaultLabel = 'x', color = 'white'}: ItemBlockProps) => item ? (
  <Tooltip title={item.id}>
    <Chip sx={{...itemBlockStyle, borderColor: color, color}} label={item.id.substring(0, 1).toUpperCase()} onClick={(e) => { e.stopPropagation(); handleClick(item.id) }} className='item'/>
  </Tooltip>
) : <Chip sx={{ ...itemBlockStyle, border: '1px dotted gray', color: 'gray' }} label={defaultLabel} className='item'/>

export default ItemBlock
